
import JSONEditor, { JSONEditorOptions } from 'jsoneditor';
import 'jsoneditor/dist/jsoneditor.min.css'
import * as React from 'react';

import './style.css';

interface IJsonEditorProps {
  name?: string;
  json: any;
  readOnly?: boolean;
  onChange?: (json: any) => void;
}
interface IJsonEditorState {
  json: object;
}

class JsonEditor extends React.Component<IJsonEditorProps, IJsonEditorState> {
  protected editor: JSONEditor;
  protected options: JSONEditorOptions;
  protected container: HTMLDivElement;
  constructor(props: any, context: any) {
    super(props, context);
    this.state = { json: this.props.json };
  }
  public componentWillReceiveProps(newProps: Readonly<IJsonEditorProps>) {
    try {
      if (JSON.stringify(this.editor.get()) !== JSON.stringify(newProps.json)) {
        this.editor.set(newProps.json);
      }
    } catch (e) {
      // Invalid JSON, let's replace the old data
      this.editor.set(newProps.json);
    }
  }
  public componentDidMount() {
    this.options = {
      name: this.props.name,
      mode: this.props.readOnly ? 'view' : 'code',
      modes: this.props.readOnly ? undefined : ['tree', 'code'],
      search: false,
      history: false,
      onChange: () => {
        try {
          if (this.props.onChange) this.props.onChange(this.editor.get());
        } catch (e) {
          // Invalid JSON, let's just ignore it
        }
      },
    };
    this.editor = new JSONEditor(this.container, this.options);
    this.editor.set(this.props.json);
  }
  public render() {
    return (
      <div className="JsonEditor" ref={r => this.container = r!} />
    );
  }
}

export default JsonEditor;



// WEBPACK FOOTER //
// ./src/JsonEditor/index.tsx